import React from 'react'

import NoteListContainer from '../sub-container/note-list-container'

const NoteList = (props) => {
  return <NoteListContainer {...props}>{props.children}</NoteListContainer>
}

export default { NoteList }
